import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MenuComponent } from './menu.component';
import { PortalModule } from '@angular/cdk/portal';
import { PosMenuController } from './pos-menu.controller';

@NgModule({
  declarations: [MenuComponent],
  imports: [CommonModule, IonicModule, PortalModule],
  exports: [MenuComponent],
  providers: [PosMenuController]
})
export class MenuModule {}
